module.exports = __webpack_public_path__ + "static/media/tj.9853139b.svg";